<template>
  <div class="seal-content">
    <img class="preview-image" :src="seal.backgroundImage"/>
    <img class="logo" src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/logo.png"/>
    <div class="title">{{seal.title}}</div>
    <div class="main-body">{{seal.mainBody}}</div>
    <div class="sn">{{seal.sn}}</div>
    <div class="create-time">颁发时间：{{seal.createTime}}</div>
    <div class="expire-time">到期时间：{{seal.expireTime}}</div>
    <img class="seal" src="http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/index.png"/>
    <div class="sign">签字/盖章:</div>
  </div>
</template>

<script>
export default {
  name: "seal",
  props:['seal']
}
</script>

<style lang="less" scoped>
.seal-content {
  width: 656px;
  height: 950px;
  max-width: 656px;
  max-height: 950px;

  .preview-image {
    width: 100%;
    height: 100%;
  }

  .logo {
    width: 300px;
    height: 80px;
    position: absolute;
    top: 180px;
    left: 195px;
  }

  .title {
    position: absolute;
    top: 300px;
    left: 100px;
    font-size: 32px;
    font-weight: 600;
  }

  .main-body {
    white-space:normal;
    word-break:break-all;
    text-indent: 1.8cm;
    position: absolute;
    width: 70%;
    line-height: 1.5cm;
    top: 400px;
    left: 100px;
    font-size: 32px;
  }

  .sn {
    position: absolute;
    top: 700px;
    left: 100px;
    font-size: 16px;
  }

  .create-time {
    position: absolute;
    top: 730px;
    left: 100px;
    font-size: 16px;
  }

  .expire-time {
    position: absolute;
    top: 760px;
    left: 100px;
    font-size: 16px;
  }

  .seal {
    position: absolute;
    right: 100px;
    bottom: 100px;
  }

  .sign {
    position: absolute;
    right: 300px;
    bottom: 100px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/certificate/seal.vue